export interface ParticipantInfo {
  membershipId: number
  employeeId: number
  employeeName: string
}

export type FileUploadStatus = 'pending' | 'uploading' | 'success' | 'error'

// File upload status constants - single source of truth
export const FileStatus = {
  PENDING: 'pending',
  UPLOADING: 'uploading',
  SUCCESS: 'success',
  ERROR: 'error',
} as const satisfies Record<string, FileUploadStatus>

export interface FileUpload {
  id: string
  file: File
  signedId: string | null
  progress: number
  status: FileUploadStatus
  error?: string
}

export interface ParticipantFiles {
  membershipId: number
  employeeId: number
  employeeName: string
  files: FileUpload[]
}

export type ParticipantFilesMap = Map<number, ParticipantFiles>

export interface MembershipWithSignedIds {
  membershipId: number
  signedIds: string[]
}
